import React, { useEffect, useState } from "react";
import BottomSheet from "./BottomSheet";
import { getAllFOSUnderCP } from "../../../Services/ChannelPartner";
import css from "./partnersMobile.module.css";

// Mobile counterpart of the desktop ViewFOSDetails modal ("View FOS Details"
// on a CP): same query, same content -- total, then each FOS's name, FOSID and
// number. That modal is a fixed 60% width with a ~10px close icon and ignores
// taps outside it, which is unusable on a phone, so it isn't reused here.
export default function CpFosListSheet({ open, cp, onClose }) {
  const [state, setState] = useState({ loading: false, error: false, list: [], count: 0 });

  useEffect(() => {
    if (!open || !cp?.cpId) return;
    let cancelled = false;
    setState({ loading: true, error: false, list: [], count: 0 });
    getAllFOSUnderCP(cp.cpId)
      .then((resp) => {
        if (cancelled) return;
        setState({
          loading: false,
          error: false,
          list: resp?.data ?? [],
          count: resp?.count ?? 0,
        });
      })
      .catch((err) => {
        if (cancelled) return;
        console.log(err);
        setState({ loading: false, error: true, list: [], count: 0 });
      });
    return () => {
      cancelled = true;
    };
  }, [open, cp?.cpId]);

  return (
    <BottomSheet open={open} title="FOS Details" onClose={onClose}>
      {state.loading && (
        <div className={css.empty} style={{ padding: "24px 0" }}>Loading…</div>
      )}

      {state.error && (
        <div className={css.empty} style={{ padding: "24px 0" }}>
          Could not load FOS. Please try again.
        </div>
      )}

      {!state.loading && !state.error && (
        <>
          <div className={css.sheetGroupTitle}>Total Fos: {state.count}</div>

          {state.count === 0 && (
            <div className={css.empty} style={{ padding: "24px 0" }}>
              <div className={css.emptyTitle}>
                No FoS found Under CP {cp?.billingName}
              </div>
            </div>
          )}

          {state.list.map((fos) => (
            <div
              key={fos.fosId}
              style={{
                padding: "12px 0",
                borderBottom: "1px solid #EAECF0",
                fontSize: 14,
                lineHeight: "20px",
              }}
            >
              <div style={{ fontWeight: 600, color: "#101828" }}>{fos.name}</div>
              <div style={{ color: "#667085" }}>FOSID{fos.fosDisplayId}</div>
              <div style={{ color: "#667085" }}>+{fos.contactNumber}</div>
            </div>
          ))}
        </>
      )}
    </BottomSheet>
  );
}
